var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63633 0.886421C6.92923 0.593526 7.4041 0.593524 7.69699 0.886415L11.7803 4.96971C11.921 5.11036 12 5.30113 12 5.50004C12 5.69895 11.921 5.88972 11.7803 6.03037L7.697 10.1137C7.4041 10.4066 6.92923 10.4066 6.63634 10.1137C6.34344 9.82081 6.34344 9.34594 6.63634 9.05304L9.43934 6.25004H0.75C0.335786 6.25004 0 5.91425 0 5.50004C0 5.08583 0.335786 4.75004 0.75 4.75004H9.43933L6.63634 1.94708C6.34344 1.65419 6.34344 1.17932 6.63633 0.886421Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default "/Frontend/static/media/arrow-right.96618b97adbed30bd3bc419089864a17.svg";
export { ForwardRef as ReactComponent };